// Keep established EasyPeasy download URLs; all other books get an ID namespace.
export function publicationPaths(book){
  const legacy=book.id.startsWith('easypeasy-');
  return {base:legacy?`downloads/${book.language}/`:`downloads/${book.id}/`,stem:legacy?'easypeasy':'book'};
}
